import Cookie from "js-cookie";
import { keys } from "lodash";
import { isDeviceKey, shouldForgetDevice } from "./rememberDevice";

const cognitoCookiePrefix = "CognitoIdentityServiceProvider";

const filterAuthEntries = (key: string) =>
  key.match(cognitoCookiePrefix) && (!isDeviceKey(key) || shouldForgetDevice());

export function clearSellerPortalAuth() {
  Object.keys(Cookie.getJSON())
    .filter(filterAuthEntries)
    .forEach((key) => Cookie.remove(key, { path: "/", domain: process.env.REACT_APP_COOKIE_DOMAIN_SELLER_PORTAL }));

  Object.keys(window.localStorage)
    .filter(filterAuthEntries)
    .forEach((key) => window.localStorage.removeItem(key));
}

// TODO: Delete this function once https://github.com/flexport/flexone/pull/38774 is stable.
// One-time cleanup for idToken cookies left on .portal.flexport.com from a now-removed temp fix (incident 2059).
// The live cookie domain is .flexport.com; these portal-scoped duplicates are stale and must be removed.
export function removeLegacyPortalFlexportCookies() {
  try {
    const legacyDomain = ".portal.flexport.com";
    keys(Cookie.getJSON())
      .filter((key) => key.startsWith(cognitoCookiePrefix))
      .forEach((key) => Cookie.remove(key, { path: "/", domain: legacyDomain }));
  } catch (e) {
    console.error("removeLegacyPortalFlexportCookies failed", e);
  }
}
